import { Box } from '@mui/system';
import React from 'react';
import errorPage from '../../assets/images/errors/banner_560x430_link non valido.svg';
import { GenericErrorTemplate } from '../../components/GenericErrorTemplate';

export const CompaniesNotFound: React.FC = () => {

    const description = (
        <Box>
            <p>
                Non &egrave; stata trovata alcuna azienda collegata a questo indirizzo e-mail.
            </p>
            <p>
                Se il problema persiste contattare l'assistenza Easyfatt.
            </p>
        </Box>
    );

    return (
        <GenericErrorTemplate
            title="Attenzione!"
            description={description}
            image={{
                alt: "Generic error image",
                src: errorPage,
                style: {
                    width: 'auto',
                    height: '321px'
                }
            }}
        />
    );
};
